<template>
    <v-container fluid>
        <v-slide-y-transition mode="out-in">

            <v-layout column>
                <v-card-title>
                    <v-btn text @click="toClienteForm()"><v-icon left>add</v-icon>Adicionar</v-btn>
                    <v-btn text @click="storeClientes.load()"><v-icon left>refresh</v-icon>Atualizar</v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Pesquisar"
                        clearable
                        single-line
                    ></v-text-field>
                </v-card-title>

                <v-data-table
                    :headers="headers"
                    :search="search"
                    :items="storeClientes.data"
                    :loading="storeClientes.isLoading"
                    :items-per-page="10"
                    sort-by="nome"
                    :footer-props="footerProps"
                    class="elevation-1"
                >
                    <template style="d-flex" v-slot:item="{ item }">
                        <tr>
                            <td class="hidden-sm-and-down">{{ item.id }}</td>
                            <td>{{ item.nome }}</td>
                            <td class="text-xs-right">
                                <v-btn icon @click="toClienteForm(item.id)" text><v-icon medium>list_alt</v-icon></v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <ClienteForm v-bind:id="clienteFormConfig.id" v-bind:showDialog="isShowClienteForm"/>
            </v-layout>
        </v-slide-y-transition>
    </v-container>
</template>

<script>

import Utils from '@/utils/Utils.js';
import { EventBus } from '@/EventBus.js';
import { Store } from '@/utils/Store.js';
import ClienteForm from '@/views/configuracoes/ClienteForm.vue'

export default {
    components: {
        ClienteForm
    },
    mounted() {
        EventBus.$on('hideClienteForm', () => {
            this.isShowClienteForm = false;
            this.clienteFormConfig.id = null;
            this.storeClientes.load();
        });
    },
    methods: {
        toClienteForm(id) {
            if (id) {
                this.clienteFormConfig.id = id;
            }
            this.isShowClienteForm = true;
        }
    },
    created() {
        this.storeClientes.load();
    },
    data() {
        return {
            tabs: 0,
            storeClientes: new Store({ url: '/clientes/Clientes' }),
            isTrue: true,
            isShowClienteForm: false,
            clienteFormConfig: {
                id: null
            },
            search: '',
            footerProps: {
                itemsPerPageOptions:  [5, 10, 25, { text: 'Todos', value: -1 }],
                itemsPerPageText: 'Registros por pagina'
            },
            headers: [
                { text: 'Id', align: 'left', sortable: false, value: 'id', width: '100', class: 'hidden-sm-and-down' },
                { text: 'Nome', align: 'left', value: 'nome' },
                { text: '', align: 'center', value: '', width: '100' }
            ]
        };
    }
}
</script>